import { ConsolidatedContact } from '../../../../../api/CoachingNotes/schema';
import { CONSOLIDATED_CONTACT_CATEGORY } from '../../../../../Util/GlobalConstants';

export const isConcessionComplianceCategory = (
  contact: ConsolidatedContact
) => {
  return (
    contact.category?.toLowerCase() ===
    CONSOLIDATED_CONTACT_CATEGORY.CONCESSION_COMPLIANCE.toLowerCase()
  );
};

export const isKudosCategory = (contact: ConsolidatedContact) => {
  return contact.category?.toLowerCase().startsWith('kudos');
};

export const isHoldRelatedCategory = (contact: ConsolidatedContact) => {
  return contact.category?.toLowerCase().includes('hold') ?? false;
};

export const isCCXCategory = (contact: ConsolidatedContact) => {
  return contact.category?.toUpperCase().includes('CCX') ?? false;
};
